import { Button, Typography } from "antd";
import { useContext } from "react";
import styled from "styled-components";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, OnboardingNavigationContext } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

const Conteudo = styled.div`
  display: grid;
  gap: 24px;
  max-width: 680px;

  .descricao {
    color: #42535b;
    font-size: 16px;
    line-height: 1.65;
    margin: 0;
  }

  .pergunta {
    color: #003644;
    font-size: 17px;
    line-height: 1.55;
    margin: 0;
  }

  .acoes {
    display: grid;
    justify-items: start;
    gap: 8px;
  }
`;

export function EtapaUtilizarVagaAssinatura({
  fluxo,
  submitting,
  onConcluir,
}: Props) {
  const { onVoltar } = useContext(OnboardingNavigationContext);

  return (
    <OnboardingFrame fluxo={fluxo} title="Você tem uma vaga para anunciar esta cota">
      <Conteudo>
        <Typography.Paragraph className="descricao">
          Você possui uma assinatura ativa da Multicotas com uma vaga disponível para anúncio.
        </Typography.Paragraph>

        <Typography.Paragraph strong className="pergunta">
          Deseja usar essa vaga para anunciar a cota que está cadastrando?
        </Typography.Paragraph>

        <div className="acoes">
          <Button
            type="primary"
            size="large"
            loading={submitting}
            onClick={() => onConcluir({ desejaUtilizarVagaAssinatura: true })}
            style={{ minWidth: 220, borderRadius: 999, background: "#003644" }}
          >
            Sim, usar esta vaga
          </Button>
          <Button
            type="text"
            disabled={submitting}
            onClick={() => onConcluir({ desejaUtilizarVagaAssinatura: false })}
          >
            Não, continuar sem vincular
          </Button>
          {onVoltar ? (
            <Button type="text" disabled={submitting} onClick={onVoltar}>
              ← Voltar
            </Button>
          ) : null}
        </div>
      </Conteudo>
    </OnboardingFrame>
  );
}
